import type { AppProps } from "next/app";
import "@/styles/globals.css";
import "@/styles/slick-carousel.css";
import { 
  SitePropertiesContext,
  AnalyticsProvider,
  logger,
  BuilderEditorSurfaceClass,
} from "@orlandohealth/build-kit";
import { builder } from "@builder.io/sdk";
import "@/registry/builder-registry";

function MyApp({ Component, pageProps }: AppProps) {
  const { siteProperties, alerts, ...otherPageProps } = pageProps;

  const apiKey = process.env.NEXT_PUBLIC_BUILDER_API_KEY;
  if (apiKey) {
    builder.init(apiKey);
    builder.apiVersion = "v3";
  } else {
    logger.error("CMS API Key is not defined");
  }

  return (
    <SitePropertiesContext.Provider
      value={{
        ...siteProperties,
        alerts: alerts || [],
      }}
    >
      <AnalyticsProvider
        algoliaAppId={process.env.NEXT_PUBLIC_ALGOLIA_APP_ID}
        algoliaSearchKey={process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_KEY}
        enableCookieBanner={process.env.NEXT_PUBLIC_ENABLE_COOKIE_BANNER !== 'false'}
      >
        <BuilderEditorSurfaceClass />
        <Component {...otherPageProps} />
      </AnalyticsProvider>
    </SitePropertiesContext.Provider>
  );
}

export default MyApp;
